export {default as assertNative} from './assertNative';
export {default as getObjectWrapper} from './getObjectWrapper';
export {default as isConstructor} from './isConstructor';
export {default as isInstanceOf} from './isInstanceOf';
export {default as isInstanceOrSubclassOf} from './isInstanceOrSubclassOf';
export {default as isNative} from './isNative';
export {default as isPlainObject} from './isPlainObject';
export {default as isSubclassOf} from './isSubclassOf';



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/index.js